export default __webpack_public_path__ + "static/media/Varied Pop 2.3d8efbc9.mp3";